const _ = require('lodash'),
    $ = require('jquery'),
    scrollSize = require('scrollbar-size');

const globalClassName = 'productCarousel-hides-cardlist-header'; // This is a CSS Feature class. See _features.less

class RrCarouselController {
    constructor($scope, $element, $timeout, $q, shelfProductService, richRelevanceService, settings) {
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.$q = $q;
        this.shelfProductService = shelfProductService;
        this.richRelevanceService = richRelevanceService;
        this.settings = settings;

        if (!this.placementId) {
            this.placementId = this.dynamicPlacementId;
        }

        $scope.$on('$destroy', () => this.removeGlobalClass());
        $scope.$on('window:widthResize', () => this.initLayout());
    }

    $postLink() {
        // We do this in postLink rather than onInit because it triggers DOM manipulation.
        // DOM manipulation is not safe before $postLink has fired.
        this.richRelevanceService.registerPlacementCallback(this.richRelevanceService.getEffectivePlacementId(this.placementId), (placement) => {
            this.removeGlobalClass();
            this.products = null;
            this.title = null;

            if (placement) {
                this.onPlacement(placement);
            }
        });

        // if a product rich relevance placment object being passed in it requires onPlacementsReceived being called
        if (this.rrPlacement) {
            this.richRelevanceService.onPlacementsReceived(this.rrPlacement);
        }
    }

    onPlacement(placement) {
        this.title = placement.message;

        const productsPromise = this.richRelevanceService.useServerSideResults(placement) && placement.Products ?
            this.$q.when(placement.Products) :
            this.shelfProductService.getProductsByStockcodes(_.map(placement.items, 'id'), true, this.richRelevanceService.rrSourceName);

        productsPromise
            .then(products => (this.products = products))
            .then(() => this.$timeout(() => this.getCarouselElements(), 0, false))
            .then(() => this.initLayout());
    }

    getCarouselElements() {
        this.$scrollWrapper = this.$element.find('._productCarousel-scrollWrapper');
        this.$scrollContainer = this.$element.find('._productCarousel-scrollContainer');
        this.$items = this.$element.find('._productCarousel-item');
    }

    get carouselScrollLeft() {
        return this.$scrollContainer.scrollLeft();
    }

    initLayout() {
        if (!this.products || this.products.length === 0) return;

        this.$scrollWrapper.height(this.$scrollContainer.outerHeight() - scrollSize());

        this.carouselScrollWidth = this.$scrollContainer.get(0).scrollWidth;
        this.carouselOffsetWidth = this.$scrollContainer.width();
        this.itemWidth = this.$items.width();

        this.addGlobalClass();
        this.displayArrow();

        this.$scrollContainer.off('scrollstop').on('scrollstop', () => {
            this.$scope.$apply(() => this.updateArrow());
        });
    }

    addGlobalClass() {
        // we add a class to html tag which will be used to hide
        // the extra space between the carousel and the card list
        // in category spaces. (Done in css).  This space is used
        // to move down the  card list to prevent overlapping with
        // the sliding panel  arrows, which is no longer the case
        // when carousel is at  the top.
        $('html').addClass(globalClassName);
    }

    removeGlobalClass() {
        $('html').removeClass(globalClassName);
    }

    /**
     * Decides whether or not the carousel should display arrows.
     *
     * @param {Number} [carouselOffsetWidth=this.carouselOffsetWidth]
     * @param {Number} [carouselScrollWidth=this.carouselScrollWidth]
     *
     * @memberOf RrCarouselController
     */
    displayArrow(
        carouselOffsetWidth = this.carouselOffsetWidth,
        carouselScrollWidth = this.carouselScrollWidth,
    ) {
        this.isScrollable = carouselScrollWidth >= carouselOffsetWidth;

        if (this.isScrollable) {
            this.updateArrow();
        }
    }

    /**
     * Toggles enabled state of left and right arrows based on current scroll position.
     *
     * @param {Number} [scrollLeft=this.carouselScrollLeft]
     * @param {Number} [carouselScrollWidth=this.carouselScrollWidth]
     * @param {Number} [carouselOffsetWidth=this.carouselOffsetWidth]
     *
     * @memberOf RrCarouselController
     */
    updateArrow(
        scrollLeft = this.carouselScrollLeft,
        carouselScrollWidth = this.carouselScrollWidth,
        carouselOffsetWidth = this.carouselOffsetWidth,
    ) {
        this.isLeftArrowDisabled = scrollLeft <= 0;
        this.isRightArrowDisabled = scrollLeft >= (carouselScrollWidth - carouselOffsetWidth);
    }

    /**
     * Calculates the new leftScroll value after scrolling left or right.
     * Scrolls by one viewport width.
     *
     * @param {Boolean} right
     * @param {Number} [itemWidth=this.itemWidth]
     * @param {Number} [scrollLeft=this.carouselScrollLeft]
     * @param {Number} [carouselWidth=this.carouselOffsetWidth]
     * @returns {Number}
     *
     * @memberOf RrCarouselController
     */
    calculateNewScrollPosition(
        right,
        itemWidth = this.itemWidth,
        scrollLeft = this.carouselScrollLeft,
        carouselWidth = this.carouselOffsetWidth,
    ) {
        const numItemsViewable = carouselWidth / itemWidth;

        let targetScroll = 0;

        if (right) {
            // move the carousel one viewport to the right
            targetScroll = scrollLeft + (numItemsViewable * itemWidth);
            // round to the nearest visible card.
            targetScroll = Math.floor(targetScroll / itemWidth) * itemWidth; // anchor to left corner of card
        } else {
            // move the carousel one viewport to the left
            targetScroll = scrollLeft - (numItemsViewable * itemWidth);
            // round to the nearest fully visible card
            targetScroll = Math.ceil(targetScroll / itemWidth) * itemWidth;
        }

        return targetScroll;
    }

    scrollLeft() {
        this.animateScrolling(this.calculateNewScrollPosition(false));
    }

    scrollRight() {
        this.animateScrolling(this.calculateNewScrollPosition(true));
    }

    animateScrolling(targetScroll) {
        this.$scrollContainer.animate({
            scrollLeft: targetScroll,
        }, 200);
    }
}

const rrCarouselComponentDefinition = {
    bindings: {
        placementId: '@',
        dynamicPlacementId: '=',
        rrPlacement: '=?',
    },
    controller: ['$scope', '$element', '$timeout', '$q', 'ShelfProductService', 'RichRelevanceService', 'Settings', RrCarouselController],
    template: require('./rr-carousel.component.html').trim(),
};

module.exports = {
    RrCarouselController,
    rrCarouselComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/richrelevance/rr-carousel.component.js